module.exports = __webpack_public_path__ + "img/climate.83574e2d.svg";